var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: { placement: "bottom", trigger: "click" },
      on: {
        hide: function ($event) {
          return _vm.hidePopperSearch(_vm.valueHere)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "th-filter-down",
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _vm._t("icon", function () {
            return [
              _c("i", {
                class: [
                  "el-icon-arrow-down",
                  _vm.iconActive ? "el-icon-arrow-down-active" : "",
                ],
              }),
            ]
          }),
        ],
        2
      ),
      _c("el-input", {
        staticClass: "input-with-select",
        attrs: {
          size: "medium",
          placeholder: _vm.placeholder || _vm.$t("admin.enterKeyword"),
          clearable: "",
        },
        model: {
          value: _vm.valueHere,
          callback: function ($$v) {
            _vm.valueHere = $$v
          },
          expression: "valueHere",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }